// Copyright (c) Hamilton Manufacturing Corp.

import React from 'react';
import styled from 'styled-components';
import CheckBox from './form/CheckBox';
import Icon from './form/Icon';
import { useGlobalState } from './globalState/GlobalStateProvider';

const Wrapper = styled.div`
    position: relative;
    color: ${({ theme }) => theme.active};
    display: flex;
    align-items: center;
    justify-content: center;
    width: 3em;
`;
const I = styled(Icon)`
    position: absolute;
    font-size: 0.7em;
    z-index: 1;
    transition: all 0.2s;
    pointer-events: none;
    left: ${({ checked }) => checked ? '25%' : '55%'};
`;
const Theme = styled(CheckBox)`
    background: ${({ theme }) => theme.gray} !important;
`;

const ThemeSelector = ({ children, ...props }) => {
    const {
        state: {
            dark_theme
        },
        setTheme
    } = useGlobalState();

    return (
        <Wrapper>
            <I icon={dark_theme ? 'sun' : 'moon'} checked={dark_theme} />
            <Theme
                standalone
                onChange={() => setTheme(!dark_theme)}
                checked={dark_theme}
            />
        </Wrapper>
    );
}

export default ThemeSelector;
